export const feedbackFormContent = {
  en: {
    // Header / meta
    headerBadge: "Session feedback",
    headerTitle: "Help your physiotherapist refine your plan",

    // Main intro
    mainTitle: "Quick check-in after your session",
    mainLead:
      "This short questionnaire helps your physiotherapist see how you responded to the session, adjust exercise difficulty, and decide which exercises are best to keep, change, or remove next time.",

    // Overall session block
    overallTitle: "Overall session feedback",
    overallText:
      "Please rate how you felt before and after the session and how demanding it was overall. These answers help track your progress over time.",

    // Per-exercise block
    perExerciseTitle: "Feedback on individual exercises",
    perExerciseText:
      "For each exercise you performed, please rate how challenging it felt and how much you liked it. This helps your physiotherapist adapt intensity and exercise selection for your next sessions.",

    // Static fields (session-level scales)
    fieldFeelingBefore: "How did you feel before the start of the session?",
    fieldFeelingAfter: "How did you feel after completing the session?",
    fieldTotalEffort: "What was the effort exerted during the session?",

    // Per-exercise difficulty + enjoyment
    exerciseDifficultyLabel: "How challenging was this exercise overall?",
    exerciseDifficultyPlaceholder: "Select an option",
    exerciseDifficultyEasy: "Easy – felt very manageable",
    exerciseDifficultyMedium: "Medium – comfortably challenging",
    exerciseDifficultyHard: "Hard – very demanding",
    exerciseEnjoymentLabel:
      "How much did you like this exercise? (1 = not at all, 6 = very much)",

    // Boolean labels (if you ever use renderBooleanField here)
    yes: "Yes",
    no: "No",

    // Errors
    validationError:
      "Please answer all required questions before submitting your feedback.",
    submitError:
      "Something went wrong while saving your feedback. Please try again.",

    // Buttons
    submitSaving: "Saving feedback...",
    submitText: "Submit feedback",
    cancelText: "Cancel",
  },

  sl: {
    // Header / meta
    headerBadge: "Povratne informacije o vadbi",
    headerTitle: "Pomagajte fizioterapevtu prilagoditi vaš načrt",

    // Main intro
    mainTitle: "Kratek pregled po koncu vadbe",
    mainLead:
      "Ta kratek vprašalnik pomaga fizioterapevtu razumeti, kako ste se odzvali na vadbo, prilagoditi težavnost vaj ter se odločiti, katere vaje je smiselno ohraniti, spremeniti ali odstraniti pri naslednjih srečanjih.",

    // Overall session block
    overallTitle: "Splošne povratne informacije o vadbi",
    overallText:
      "Prosimo, ocenite, kako ste se počutili pred in po vadbi ter kako zahtevna je bila celotna vadba. Ti odgovori pomagajo spremljati vaš napredek skozi čas.",

    // Per-exercise block
    perExerciseTitle: "Povratne informacije za posamezne vaje",
    perExerciseText:
      "Za vsako vajo, ki ste jo izvedli, ocenite, kako zahtevna se vam je zdela in kako vam je bila všeč. S tem fizioterapevt lažje prilagodi intenzivnost in izbor vaj v prihodnjih vadbah.",

    // Static fields (session-level scales)
    fieldFeelingBefore: "Kako ste se počutili pred začetkom vadbe?",
    fieldFeelingAfter: "Kako ste se počutili po zaključku vadbe?",
    fieldTotalEffort: "Kolikšen napor ste vložili med vadbo?",

    // Per-exercise difficulty + enjoyment
    exerciseDifficultyLabel: "Kako zahtevna se vam je zdela ta vaja?",
    exerciseDifficultyPlaceholder: "Izberite možnost",
    exerciseDifficultyEasy: "Lahka – zelo obvladljiva",
    exerciseDifficultyMedium: "Srednja – prijetno zahtevna",
    exerciseDifficultyHard: "Težka – zelo naporna",
    exerciseEnjoymentLabel:
      "Kako zelo vam je bila ta vaja všeč? (1 = sploh ne, 6 = zelo)",

    // Boolean labels
    yes: "Da",
    no: "Ne",

    // Errors
    validationError:
      "Pred oddajo povratnih informacij prosimo izpolnite vsa obvezna vprašanja.",
    submitError:
      "Pri shranjevanju povratnih informacij je prišlo do napake. Poskusite znova.",

    // Buttons
    submitSaving: "Shranjevanje povratnih informacij...",
    submitText: "Oddaj povratne informacije",
    cancelText: "Prekliči",
  },
} as const;